import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';

export const formLabelTheme: ThemeOptions['components'] = {
  DsFormLabel: {
    styleOverrides: {
      root: {
        fontSize: '12px',
        lineHeight: '18px',
        color: tokens.theme.fg.structural.primary,
        fontWeight: 500,
        transform: 'unset',
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
        marginBottom: '4px',
        '.Mui-error &, .Mui-focused &, .Mui-disabled &, &.DS-disabled, .DS-Input-readOnly &':
          {
            color: tokens.theme.fg.structural.primary,
          },
      },
      sm: {
        fontSize: '10px',
        lineHeight: '16px',
      },
      md: {
        fontSize: '12px',
        lineHeight: '18px',
      },
      lg: {
        fontSize: '12px',
        lineHeight: '18px',
      },
      icon: {
        fontSize: '1.1em',
        pointerEvents: 'initial',
      },
      empty: {
        whiteSpace: 'pre',
      },
    },
  },
};
